import ExoDialog from '../../exo/ExoDialog';
import { useState } from 'react';
import LabeledBox from '../../special/LabeledBox';
import { MatchingPropertiesList } from '../../exo/matching-properties/MatchingPropertiesList';
import { MatchingPropertieShow } from '../../exo/matching-properties/MatchingPropertieShow';
import { Box, Button } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from 'react-i18next';
import { updateOrCreate } from '../../special/updateOrCreate';

export const TypeSalesObjectPropertiesCustomer = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
  onFocus,
  onBlur,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  function handleChangedSelection(selection) {
    updateValidationOnChange([field.key], selection);
    setOpen(false);
  }

  function handlePropChange(data) {
    const newProps = updateOrCreate(dataCollection[field.key], data.data);
    handleChangedSelection(newProps);
  }

  const properties = dataCollection[field.key];

  return (
    <Box className="flex flex-col gap-4">
      {properties?.map((property) => (
        <MatchingPropertieShow
          key={property.id}
          property={property}
          isEditMode
          onChange={handlePropChange}
          isLead
        />
      ))}
    </Box>
  );
};
